import { Dashboard, Users } from '@/components';

export const UserListPage = (): JSX.Element => (
  <Dashboard>
    <Users />
  </Dashboard>
);
